import React from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IconButton, Tooltip } from '@mui/material';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';

const DownloadPdfFile = ({ data }) => {
    const [formatedData,setFormatedData] = React.useState([])

    React.useEffect(()=>{
        const dataValue = data.map((r)=>{
            return{
                "Test Code": r?.test_code || '',
                "Test Name": r?.test_name || '',
                // "Methodology": "Direct Measure PEG/Enzymatic/Enzymatic (CHE/CHO/POD)/Enzymatic(Lipase/GK/GPO/POD)/Glycerol Phosphate Oxidase/peroxidase/Homogenous Enzymatic Direct Assay",
                "Price": r?.mrp || '',
                "Tat": r?.tat,
                "Sample Type": r?.sampleType_name || '',
                "Disease Name": r?.disease_name || 'He t4, ft3, ft4, tsh, caat (t3  Pat4, ft3dlatipn tsh'
            }
        })
        setFormatedData(dataValue)
    },[data])


    const downloadPDF = () => {
        const doc = new jsPDF();
    
        const columns = Object.keys(formatedData[0]);
        const rows = formatedData.map(obj => Object.values(obj));
    
        // Calculate the width of the table
        const tableWidth = columns.reduce((acc, column) => acc + column.length * 6, 0);
    
        // Set a minimum width for the table
        const minWidth = 120;
        const lineHeight = 15;
        // If the calculated width is less than the minimum width, use the minimum width
        const width = tableWidth < minWidth ? minWidth : tableWidth;
    
        // Add a table to the PDF document with adjustable size
        doc.autoTable({
          head: [columns],
          body: rows,
          theme: 'grid',
          margin: { top: 10 },
          tableWidth: 'wrap', // 'auto', 'wrap', 'number' or 'fill'
          tableLineWidth: 0.2,
          styles: {
            cellPadding: 2,
            fontSize: 7,
            valign: 'middle',
            halign: 'center'
          },
          columnStyles: {
            0: { cellWidth: "wrap" },
            1: { cellWidth: "wrap" },
            2: { cellWidth: "wrap" },
            3: { cellWidth: "wrap" }
            
            // Add more columnStyles as needed
          }
        });
    
        // Save the PDF
        doc.save('data.pdf');
      };
    

  return (
    <Tooltip
    title={"Download as pdf"}
    placement="top-start"
    >
      <IconButton onClick={downloadPDF}><SimCardDownloadIcon/></IconButton>
    </Tooltip>
  );
};


export default DownloadPdfFile